type ParameterLabelProps = {
  label: string;
  required?: boolean;
};

export const ParameterLabel = ({ label, required }: ParameterLabelProps) => {
  return (
    <span className="w-85 text-s18 wrap-break-word shrink-0">
      {required && <span className="text-text-status-red-lighter">*</span>} {label}
    </span>
  );
};
